<template>
  <Modal class='common-modal' v-bind="$attrs" v-on="$listeners">
    <slot/>
  </Modal>
</template>
<script>
import { Modal } from 'ant-design-vue'
export default {
  components: {
    Modal
  }
}
</script>
<style lang="less">
.common-modal {
  .ant-modal-content{
    border-radius: 0;

    .ant-modal-close-x{
      width: 40px;
      height:40px;
      line-height: 40px;
    }

    .ant-modal-header{
      padding: 9px 30px;
      font-size: 16px;
      color: #333333;
      position: relative;

      &::before{
        position: absolute;
        content: '';
        width: 3px;
        height: 12px;
        background-color: #1C7AE5;
        left: 20px;
        top: 14px;
      }
    }
  }
}
</style>
